/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Err_Not_SellableInputs */

const vi_product_lot_err_not_sellable = /** @type {(inputs: Product_Lot_Err_Not_SellableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có lô đang ở kệ hàng lỗi, không được bán. Chọn lô khác.`)
};

/**

* @param {Product_Lot_Err_Not_SellableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_err_not_sellable = /** @type {((inputs?: Product_Lot_Err_Not_SellableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Err_Not_SellableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_err_not_sellable(inputs)
});